import { Component, OnInit, Inject } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { incidenciaDetalleQABean } from 'src/app/shared/model/incidencias/incidenciaDetalleQABean.model';
import { MatIconButton } from '@angular/material/button';
import { MatIcon } from '@angular/material/icon';
import { NgFor, NgIf } from '@angular/common';
import { MatFormField, MatLabel, MatInput } from '@angular/material/input';
import { FormsModule } from '@angular/forms';
import { nombreDeIntegrante } from '../etapa-incidencia.util';

@Component({
    selector: 'app-historial',
    standalone: true,
    templateUrl: './historial.component.html',
    styleUrls: ['./historial.component.css'],
    imports: [MatIconButton, MatIcon, NgFor, NgIf, MatFormField, MatLabel, MatInput, FormsModule]
})
export class HistorialComponent implements OnInit {

  parameter: any;

 
  constructor(public dialogRef: MatDialogRef<HistorialComponent>, @Inject(MAT_DIALOG_DATA) private paramet: any) { }

  ngOnInit() {
    this.parameter = this.paramet;
    this.procesaListaHistorial(this.parameter.dataListaHis);
  }

  procesaListaHistorial(listaHistorial: incidenciaDetalleQABean[]){
    for(let i = 0; i < (listaHistorial?.length ?? 0); i++){
      listaHistorial[i].nombre_emp_asignado  = listaHistorial[i].id_emp_asignado === 0 ? "NA" : this.procesaNombre(listaHistorial[i].id_emp_asignado);
      listaHistorial[i].nombre_emp_reasignado = this.procesaNombre(listaHistorial[i].id_emp_reasignado);
    }

  }

  /**
   * Quien ya no está en el equipo de la etapa (o con la lista vacía) tronaba
   * aquí y el historial no abría: ahora sale sin nombre.
   */
  procesaNombre(id: number): string{
    return nombreDeIntegrante(this.parameter.dataListaEmp, id) ?? "Sin nombre";
  }

  onCloseClick() {
    this.dialogRef.close();
  }

}
